import React from "react";

export default function PageHeader({ title, description, actions, testId }) {
    return (
        <div className="flex items-start justify-between gap-6 border-b border-zinc-200 px-8 py-6" data-testid={testId || "page-header"}>
            <div>
                <h1 className="font-display text-2xl font-semibold tracking-tight text-zinc-950">{title}</h1>
                {description && (
                    <p className="mt-1 max-w-2xl text-sm text-zinc-500 leading-relaxed">{description}</p>
                )}
            </div>
            {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
    );
}
